export default function mergeObjects<T extends object>(obj1: T, obj2: Partial<T>): T {
    for (const key in obj2) {
        if ((obj1[key] === null || obj1[key] === undefined) && obj2[key] !== undefined) {
            obj1[key] = obj2[key] as T[Extract<keyof T, string>];
        }
    }
    return obj1;
}
